import styled, { keyframes } from 'styled-components';
import Scrollspy from 'react-scrollspy';
import AppBar from '@material-ui/core/AppBar';
import { slideInDown } from 'react-animations';

const SlideInDownAnimation = keyframes`${slideInDown}`;

const RevealedContainer = styled.div`
  display: none;
  :not(.scrolled-past) {
    display: block;
  }
`;

const SubHeaderContainer = styled.div`
  animation: 250ms ${SlideInDownAnimation};
  width: ${({ width }) => width || '100%'};
  background-color: ${({ backgroundColor }) => backgroundColor || 'red'};
  box-shadow: none;
  top: 64px;
  z-index: 1099;

  & .wrapper {
    background-color: rgba(0, 0, 0, 0.15);
  }
`;

/**
 *
 * @param root0
 * @param root0.content
 * @param root0.isRevealed
 */
export default function SubHeader({ content, isRevealed }) {
  const Header = () => (
    <SubHeaderContainer>
      <AppBar position="fixed">
        <div className="wrapper">{content}</div>
      </AppBar>
    </SubHeaderContainer>
  );

  if (!isRevealed) {
    return Header;
  }

  return (
    <RevealedContainer>
      <Scrollspy items={['scroll-past']} currentClassName="scrolled-past">
        {Header}
      </Scrollspy>
    </RevealedContainer>
  );
}
